<template>
  <span v-if="isLoading" class="text-gray-400">{{ loadingText }}</span>
  <span v-else-if="convertedValue">{{ convertedValue }}</span>
  <span v-else class="text-gray-400">N/A</span>
</template>

<script>
import { formatCurrencyWithConversion } from "@/utils/currency.utils";

export default {
  name: "CurrencyDisplay",
  props: {
    amount: {
      type: Number,
      default: null,
    },
    countryCode: {
      type: String,
      default: "US",
    },
  },
  data() {
    return {
      convertedValue: null,
      isLoading: false,
    };
  },
  computed: {
    loadingText() {
      return this.countryCode === "US" ? "$..." : "...";
    },
  },
  watch: {
    amount: {
      immediate: true,
      handler() {
        this.convertCurrency();
      },
    },
    countryCode: {
      immediate: true,
      handler() {
        this.convertCurrency();
      },
    },
  },
  methods: {
    async convertCurrency() {
      if (!this.amount || this.amount === 0) {
        this.convertedValue = null;
        return;
      }

      this.isLoading = true;

      try {
        this.convertedValue = await formatCurrencyWithConversion(
          this.amount,
          this.countryCode
        );
      } catch (error) {
        console.error("Currency conversion error:", error);
        this.convertedValue = `$${this.amount.toFixed(2)}`;
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>
